module.exports = __webpack_public_path__ + "static/media/checked2.6f298cca.png";